'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

SharedWidthSubscriberDirective=class SharedWidthSubscriberDirective extends BaseControllerBackedDirective{
get restrict(){
return'A';
}
get textBindings(){
return['name'];
}
get controller(){
return SharedWidthSubscriberDirectiveController;
}};let


SharedWidthSubscriberDirectiveController=class SharedWidthSubscriberDirectiveController{
static get $inject(){
return['$rootScope','$scope','$element'];
}

constructor($rootScope,$scope,$element){
this._$rootScope=$rootScope;

$scope.$watch('controller._sharedWidth',newWidth=>{
$element[0].style.width=`${newWidth}px`;
});
}

get _sharedWidth(){
return _.exists(this._$rootScope.sharedWidths)?this._$rootScope.sharedWidths[this.name]:void 0;
}};


module.exports=SharedWidthSubscriberDirective;
//# sourceMappingURL=sharedWidthSubscriberDirective.js.map
